import React, { useState } from "react";
import { Typography, Grid, Box, Card, TextField, InputAdornment, CardContent } from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PercentIcon from "@mui/icons-material/Percent";
import moment from "moment";

export default function FormActualizar(props) {
  const { datosExisten, datoslista, style, setDatoslista, fechaFinVigenciaFormat, almacenar, aumento, setAumento, porcentaje, setPorcentaje } = props;

  //AUMENTO EN PESO ******//
  const [desactivarPorcentaje, setDesactivarPorcentaje] = useState(false);
  const [desactivarPesos, setDesactivarPesos] = useState(false);


  const handleAumentoChange = (e) => {
    const nuevoAumento = e.target.value;
    setAumento(nuevoAumento);
    setDesactivarPorcentaje(nuevoAumento !== "");

    if (!isNaN(nuevoAumento) && nuevoAumento !== "") {
      setDatoslista({
        ...datoslista,
        lt_con_iva: (datosExisten[0].lt_con_iva + parseFloat(nuevoAumento)).toFixed(2),
        lt_sin_iva: (datosExisten[0].lt_sin_iva + parseFloat(nuevoAumento)).toFixed(2),
        kg_con_iva: (datosExisten[0].kg_con_iva + parseFloat(nuevoAumento)).toFixed(2),
        kg_sin_iva: (datosExisten[0].kg_sin_iva + parseFloat(nuevoAumento)).toFixed(2),
      });
    } else {
      setDatoslista({
        ...datoslista,
        lt_con_iva: datosExisten[0].lt_con_iva.toFixed(2),
        lt_sin_iva: datosExisten[0].lt_sin_iva.toFixed(2),
        kg_con_iva: datosExisten[0].kg_con_iva.toFixed(2),
        kg_sin_iva: datosExisten[0].kg_sin_iva.toFixed(2),
      });
    }
  };

  //*AUMENTO EN PORCENTAJE ***************************//


  const handlePorcentajeChange = (e) => {
    const nuevoPorcentaje = e.target.value;
    setPorcentaje(nuevoPorcentaje);
    setDesactivarPesos(nuevoPorcentaje !== "");

    if (!isNaN(nuevoPorcentaje) && nuevoPorcentaje !== "") {
      const porcentajeNumerico = parseFloat(nuevoPorcentaje) / 100;

      setDatoslista({
        ...datoslista,
        lt_con_iva: (datosExisten[0].lt_con_iva * (1 + porcentajeNumerico)).toFixed(2),
        lt_sin_iva: (datosExisten[0].lt_sin_iva * (1 + porcentajeNumerico)).toFixed(2),
        kg_con_iva: (datosExisten[0].kg_con_iva * (1 + porcentajeNumerico)).toFixed(2),
        kg_sin_iva: (datosExisten[0].kg_sin_iva * (1 + porcentajeNumerico)).toFixed(2),
      });
    } else {
      setDatoslista({
        ...datoslista,
        lt_con_iva: datosExisten[0].lt_con_iva.toFixed(2),
        lt_sin_iva: datosExisten[0].lt_sin_iva.toFixed(2),
        kg_con_iva: datosExisten[0].kg_con_iva.toFixed(2),
        kg_sin_iva: datosExisten[0].kg_sin_iva.toFixed(2),
      });
    }
  };


  const formatoParaMostrar = (valor) => {
    if (valor === null || valor === undefined) return '';
    // Si es número, lo paso a string con coma
    if (typeof valor === 'number') {
      return valor.toFixed(2).replace('.', ',');
    }
    // Si es string, reemplazo punto por coma
    return valor.replace('.', ',');
  };


  return (
    <>
      {datosExisten && (
        <Box sx={{ padding: 2 }}>
          {/* Card para Precio Vigente */}
          <Card variant="outlined" sx={{ mb: 1, backgroundColor: "#F4F6F6" }}>
            <CardContent>
              <Typography sx={{ fontSize: 19, mb: 2, textDecoration: "underline", textAlign: "center" }}>
                Precio Vigente
              </Typography>
              {/* Precios en un solo renglón */}
              <Grid container spacing={1} alignItems="center" justifyContent="center">
                {[
                  { label: "Precio litro sin IVA", value: datosExisten[0].lt_sin_iva || 0 },
                  { label: "Precio litro con IVA", value: datosExisten[0].lt_con_iva || 0 },
                  { label: "Precio kilo sin IVA", value: datosExisten[0].kg_sin_iva || 0 },
                  { label: "Precio kilo con IVA", value: datosExisten[0].kg_con_iva || 0 },
                ].map((item, index) => (
                  <Grid item xs={12} sm={6} md={2} key={index}>
                    <TextField
                      fullWidth
                      style={style}
                      focused
                      size="small"
                      variant="outlined"
                      label={item.label}
                      value={formatoParaMostrar(item.value)}
                      InputProps={{ readOnly: true }}

                    />
                  </Grid>
                ))}
                {/* Fechas de Vigencia */}
                <Grid item xs={12} sm={6} md={2}>
                  <TextField
                    fullWidth
                    style={style}
                    focused
                    size="small"
                    variant="outlined"
                    label="Entrada en Vigencia"
                    value={moment(datosExisten[0].vigencia).format("DD-MM-YYYY") || ""}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <TextField
                    fullWidth
                    style={style}
                    focused
                    size="small"
                    variant="outlined"
                    label="Fin Vigencia"
                    value={moment(datosExisten[0].fin_vigencia).format("DD-MM-YYYY") || "No hay registro"}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
              </Grid>
            </CardContent>

            <CardContent>
              <Typography sx={{ fontSize: 19, mb: 2, textDecoration: "underline", textAlign: "center" }}>
                Actualización
              </Typography>
              <Grid container spacing={1} alignItems="center" justifyContent="center">
                <Grid item xs={12} sm={6} md={2}>
                  <TextField
                    fullWidth
                    style={style}
                    focused
                    size="small"
                    color="secondary"
                    label="Actualización en pesos"
                    variant="outlined"
                    value={aumento}
                    onChange={handleAumentoChange}
                    disabled={desactivarPesos}
                    InputProps={{
                      startAdornment: <InputAdornment position="start"><AttachMoneyIcon /></InputAdornment>,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <TextField
                    fullWidth
                    size="small"
                    style={style}
                    focused
                    color="secondary"
                    label="Actualización en porcentaje"
                    variant="outlined"
                    value={porcentaje}
                    onChange={handlePorcentajeChange}
                    disabled={desactivarPorcentaje}
                    InputProps={{
                      startAdornment: <InputAdornment position="start"><PercentIcon /></InputAdornment>,
                    }}
                  />
                </Grid>
              </Grid>
            </CardContent>

            <CardContent>
              <Typography sx={{ fontSize: 19, mb: 2, textDecoration: "underline", textAlign: "center" }}>
                Precio actualizado
              </Typography>
              {/* Precios con aumento en un solo renglón */}
              <Grid container spacing={1} alignItems="center" justifyContent="center">
                {[
                  { label: "Precio litro sin IVA", name: "lt_sin_iva", value: datoslista.lt_sin_iva || 0 },
                  { label: "Precio litro con IVA", name: "lt_con_iva", value: datoslista.lt_con_iva || 0 },
                  { label: "Precio kilo sin IVA", name: "kg_sin_iva", value: datoslista.kg_sin_iva || 0 },
                  { label: "Precio kilo con IVA", name: "kg_con_iva", value: datoslista.kg_con_iva || 0 },
                ].map((item, index) => (
                  <Grid item xs={12} sm={6} md={2} key={index}>
                    <TextField
                      fullWidth
                      style={style}
                      focused
                      size="small"
                      variant="outlined"
                      label={item.label}
                      name={item.name}
                      value={formatoParaMostrar(item.value)}
                      onChange={almacenar}
                      InputProps={{ startAdornment: <InputAdornment position="start"><AttachMoneyIcon /></InputAdornment> }}
                      onKeyDown={(e) => {
                        if (e.key === '.') {
                          e.preventDefault();
                        }
                      }}
                      onPaste={(e) => {
                        const pastedText = e.clipboardData.getData('text');
                        if (pastedText.includes('.')) {
                          e.preventDefault();
                        }
                      }}
                      inputProps={{
                        inputMode: 'decimal',
                        pattern: '[0-9]*[,]{0,1}[0-9]{0,2}',
                      }}
                    />
                  </Grid>
                ))}
                {/* Fecha Minima */}
                <Grid item xs={12} sm={6} md={2}>
                  <TextField
                    fullWidth
                    style={style}
                    focused
                    required
                    size="small"
                    variant="outlined"
                    label="Entrada en vigencia"
                    type="date"
                    name="vigencia"
                    value={datoslista.vigencia || ""}
                    onChange={almacenar}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <TextField
                    fullWidth
                    style={style}
                    focused
                    size="small"
                    variant="outlined"
                    label="Fin vigencia"
                    type="date"
                    name="fin_vigencia"
                    value={datoslista.fin_vigencia || ""}
                    onChange={almacenar}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Box>
      )}
    </>
  )
}